import type { Role } from "../types";

export function canManageAccess(role: Role) { return role === "POSITRONICO_OWNER"; }
export function canEditProject(role: Role) { return role === "POSITRONICO_OWNER" || role === "CLIENT_ADMIN" || role === "CLIENT_MEMBER"; }
export function canDeleteProjectData(role: Role) { return role === "POSITRONICO_OWNER" || role === "CLIENT_ADMIN"; }
export function canEditRoadmap(role: Role) { return role === "POSITRONICO_OWNER"; }
export function canOpenProject(role: Role) { return role === "POSITRONICO_OWNER" || role === "CLIENT_ADMIN"; }
export function canManageDecisions(role: Role) { return role === "POSITRONICO_OWNER"; }
export function projectTabsFor(role: Role) {
  return role === "POSITRONICO_OWNER"
    ? ["roadmap", "pending", "development", "meetings", "decisions", "changes", "members"] as const
    : role === "CLIENT_ADMIN"
      ? ["roadmap", "pending", "meetings", "decisions", "changes"] as const
      : [] as const;
}
export function canManageCommercial(role: Role) { return role === "POSITRONICO_OWNER"; }
export function canApproveQuotes(role: Role) { return role === "CLIENT_ADMIN"; }
